import React from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { SetupSearch } from 'areas/shared/pages/setup';
import { DateRangePicker, SearchBox, CheckBox } from 'fw/forms';
import { EmailStatusCombo, EmailCategoryCombo, UserTypeCombo } from 'areas/shared/controls';
import * as API from 'modules/app/API';

class Search extends SetupSearch {

    initialForm() {
        return {
            searchText: "",
			clientTimeZoneOffset: - new Date().getTimezoneOffset()/60
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    searchLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: { type: 'emailingLog' }
        }
    }

    renderForm() {
		var checkboxStyle = {
			marginTop: 7,
			marginBottom: 0
		};

        return (
            <Row>
                <Col md={4} style={{ paddingRight: 10 }}>
                    <FormGroup style={{marginBottom: '5px'}}>
                        <SearchBox
                            name="searchText"
                            placeholder="Search sent e-mails..."
                            loader={this.searchLoader}
                            ref={(c) => { this.focusControl = c }} />
                    </FormGroup>
                    <FormGroup>
                        <EmailStatusCombo name="emailStatusCode" placeholder="Email Status" clearable/>
                    </FormGroup>
                </Col>
                <Col md={4} style={{ paddingLeft: 10, paddingRight: 10 }}>
						<DateRangePicker name="dateRange" placeholder="Date" futureOptions={false}/>
				</Col>
                <Col md={2} style={{ paddingLeft: 10, paddingRight: 10 }}>
                    <EmailCategoryCombo 
						name="emailCategory" 
						onChange={this.search} 
                        clearable 
						placeholder="All Categories"/>
					<FormGroup>
						<Row>
							<Col md={4}>
								<CheckBox style={checkboxStyle} name="clicked" label="Clicked" />
							</Col>
							<Col md={8}>
								<CheckBox style={checkboxStyle} name="opened" label="Opened" />
							</Col>
						</Row>
					</FormGroup>
				</Col>
                <Col md={2} style={{ paddingLeft: 10 }}>
                    <UserTypeCombo 
                        name="recipientsType" 
                        clearable 
                        onChange={this.search}
                        placeholder="All Recipient Types"/>
				</Col>
            </Row>
        )
    }
}

export default Search;


// WEBPACK FOOTER //
// ./src/areas/admin/emailingLog/Search.js